export default __webpack_public_path__ + "static/ProValue_4-654823a2e260d0d82359f93aa245d0a2.png";